
const UpstreamProjects = () => {
  const upstreamProjects = [
    {
      category: "Drilling Operations",
      image: "https://public.readdy.ai/ai/img_res/1f2ba5042594f89d79e2640ed1fc5999.jpg",
      projects: [
        "High-performance drilling fluid systems for complex formations",
        "Lost circulation materials for challenging drilling conditions",
        "Wellbore stability chemicals for extended reach drilling",
        "Drilling fluid additives for HPHT environments"
      ]
    },
    {
      category: "Well Completion",
      image: "https://readdy.ai/api/search-image?query=Well%20completion%20operations%20with%20Golden%20Black%20chemical%20solutions%2C%20completion%20fluids%20and%20equipment%2C%20professional%20wellhead%20operations%2C%20upstream%20completion%20chemicals%20with%20technical%20monitoring%20systems%20and%20safety%20equipment&width=600&height=400&seq=upstream-completion&orientation=landscape",
      projects: [
        "Completion fluids for reservoir protection",
        "Acid stimulation chemicals for productivity enhancement",
        "Fracturing fluid systems for unconventional reservoirs",
        "Cleanup additives for post-completion operations"
      ]
    },
    {
      category: "Production Enhancement",
      image: "https://readdy.ai/api/search-image?query=Production%20enhancement%20operations%20with%20Golden%20Black%20chemicals%2C%20oil%20production%20facilities%20with%20chemical%20injection%20systems%2C%20upstream%20production%20optimization%20equipment%2C%20professional%20production%20chemical%20management%20with%20monitoring%20systems&width=600&height=400&seq=upstream-production&orientation=landscape",
      projects: [
        "Enhanced oil recovery (EOR) chemical programs",
        "Water flooding optimization chemicals",
        "Gas lift optimization solutions",
        "Artificial lift chemical treatments"
      ]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Upstream Chemical Supply Projects
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive chemical solutions for drilling, completion, and production operations 
            designed to optimize performance and maximize recovery rates.
          </p>
        </div>

        <div className="space-y-12">
          {upstreamProjects.map((project, index) => (
            <div key={index} className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                <img
                  src={project.image}
                  alt={project.category}
                  className="w-full h-80 object-cover object-top rounded-lg shadow-lg"
                />
              </div>
              <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {project.category}
                </h3>
                <div className="space-y-3">
                  {project.projects.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-start space-x-3">
                      <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <p className="text-gray-700 text-lg">{item}</p>
                    </div>
                  ))}
                </div>
                <div className="mt-6 p-4 bg-teal-50 rounded-lg">
                  <p className="text-teal-800 font-semibold">
                    <i className="ri-star-line mr-2"></i>
                    Specialized formulations for UAE reservoir conditions and ADNOC specifications
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpstreamProjects;
